import hackerrank from '../assets/svg/Certificates/HackerRank.png';
import rbsc from '../assets/svg/Certificates/BSER.png';

export const achievementData = {
  ach1: [
    {
      id: 1,
      bio: 'Rated Knight on Leetcode [Max: 1989 (top 2%)]',
    },
    {
      id: 2,
      bio: 'Rated Specialist on Codeforces [Max: 1493]',
    },
    {
      id: 3,
      bio: "AIR 2957 out of 1,00,000+ registered participants in CodeKaze Sept'2023 [by Coding Ninjas]",
    },
    {
      id: 4,
      bio: 'Secured Global Rank 1453 out of 21,100+ participants in Leetcode Weekly Contest 369',
    },
    {
      id: 5,
      bio: 'Secured Global Rank 964 out of 13,000+ participants in Codeforces Round 901 [Div 2]',
    },
  ],
  achievements: [
    {
      id: 1,
      title: 'Certification of Merit',
      details: 'All India Rank 2957 in CodeKaze by Coding Ninja',
      date: 'Sept, 2023',
      certificate:
        'https://drive.google.com/file/d/12zhIHA-DUXmLRWnd5m7i40hYWKZbUYKM/view',
      image: rbsc,
    },
  ],
};

// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/
